import "@fontsource-variable/inter";
import "@fontsource-variable/roboto-flex";
import "@mdi/font/css/materialdesignicons.css";
import "splitpanes/dist/splitpanes.css";
import "vuetify/styles";

import { vMaska } from "maska/vue";
import { createPinia } from "pinia";
import { createApp } from "vue";
import vuetify from "./plugins/vuetify";
import router from "./router";

import App from "./App.vue";

// Need to import custom css that may change vuetify after vuetify was created
import "./assets/main.css";
import "./assets/markdown.css";

const pinia = createPinia();

const app = createApp(App);
app.directive("maska", vMaska);
app.use(pinia);

app.use(router);

app.use(vuetify);

router.isReady().then(() => {
  app.mount("#app");
});
